// The one builder of the line icons of the chrome: the dock, the alarm
// screen, the chat, the INBOX, the view panel and the session block of
// OPTIONS. They are one family: a 24-unit box, a stroke of 1.7 with round
// caps and joins, in `currentColor`, so the ink of the host is the ink of
// its icon. Every icon is hidden from a screen reader, because its host
// states its sense in words. The module imports nothing.

/** One line icon with the class `cls`, `px` square, that draws `paths`
 *  (the inner markup in the 24-unit box). */
export function lineIcon(cls: string, px: number, paths: string): string {
  return `<svg class="${cls}" viewBox="0 0 24 24" width="${px}" height="${px}" fill="none" stroke="currentColor"`
    + ' stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">'
    + `${paths}</svg>`;
}
